const SESSION_POST_URL = 'https://api-b7f90015.moot.tech/mv/api/2023-01/session_post';

async function fetchCart() {
    const response = await fetch('/cart.js');
    const cart = await response.json();

    delete cart.note;
    cart.items = cart.items.map(item => {
        delete item.product_description;
        return item;
    });

    return cart;
}

function getAnalyticsData() {
    const analytics = window.ShopifyAnalytics;
    const attributes = analytics.lib.trekkie.defaultAttributes;
    const navigationInfo = analytics.lib.navigationInfo;
    const meta = analytics.meta;
    const page = window.meta.page;
    const product = meta.product;

    return { attributes, navigationInfo, meta, page, product };
}

async function createBody(options) {
    const { cartFetch = true, payload = {} } = options;
    const cart = cartFetch ? await fetchCart() : undefined;
    const { attributes, navigationInfo, meta, page, product } = getAnalyticsData();

    return {
        sessionKey: attributes.visitToken.replace(/-/g, '').toLowerCase(),
        visitorKey: attributes.uniqToken.replace(/-/g, '').toLowerCase(),
        customerKey: page.customerId?.toString(),
        url: window.location.href,
        referrer: document.referrer,
        navigationType: navigationInfo.navigationType,
        pageType: page.pageType ?? 'unknown',
        resourceKey: page.resourceId?.toString(),
        product: product ? {
            key: product.id.toString(),
            variantKey: meta.selectedVariantId
        } : undefined,
        cart,
        ...payload
    };
}

async function sendBeacon(url, body) {
    try {
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(body)
        });

        if (!response.ok) {
            throw new Error(`HTTP error ${response.status}: ${response.statusText}`);
        }

        return response;
    } catch (error) {
        console.error(`Error sending beacon: ${error.message}`);
        return null;
    }
}

async function sendPageViewBeacon() {
    const options = { cartFetch: true };
    const body = await createBody({ ...options, payload: { kind: 'pageview' } });
    return await sendBeacon(SESSION_POST_URL, body);
}

// send a pageview beacon when this script has finished loading
(async () => {
    await sendPageViewBeacon();
})();

// register other beacons on the browsers window object so we can request when needed
window.sendRecommendationClickEventBeacon = async function(eventData) {
    const options = { cartFetch: false };
    const payload = { kind: 'rec_click', ...eventData };
    const body = await createBody({ ...options, payload });
    return await sendBeacon(SESSION_POST_URL, body);
}

window.sendSimilarClickEventBeacon = async function(eventData) {
    const options = { cartFetch: false };
    const payload = { kind: 'similar_click', ...eventData };
    const body = await createBody({ ...options, payload });
    return await sendBeacon(SESSION_POST_URL, body);
}

window.sendAddToBasketClickEventBeacon = async function() {
    const options = { cartFetch: false };
    const payload = { kind: 'add_to_basket'}
    const body = await createBody({ ...options, payload });
    return await sendBeacon(SESSION_POST_URL, body);
}
